import React, { useEffect } from 'react'
import { withRouter, useLocation } from 'react-router-dom'
import { logout } from '../../helpers/authHelper'

const SSOPageRawLogout = () => {
  const location = useLocation()

  useEffect(() => {
    // get current window location,
    // if contains redirect query param, redirect to that URL
    const redirectUrl = new URLSearchParams(window.location.search).get('redirect')
    logout(redirectUrl);
  }, []);

  return (
    // empty page to handle SSO logout
    <>System is helping you log out...</>
  )
}

export const SSOLogoutPage = withRouter(SSOPageRawLogout)
